export default __webpack_public_path__ + "static/media/gallery_01.2ff586a7.jpg";